import { supabase } from "@/lib/supabase/client";
import { updateMyProfile } from "@/features/identity/api/profileApi";

// DB trigger enforces the activation entitlement; onboarding is marked complete only after both rows publish.
export async function publishMyIdentity(card, publicProfile) {
  const { error: cardError } = await supabase.from("digital_cards").update({ status: "published" }).eq("id", card.id).select("id").single();
  if (cardError) throw cardError;

  const { data: pp, error: ppError } = await supabase
    .from("public_profiles")
    .update({ status: "published" })
    .eq("id", publicProfile.id)
    .select("id,status,published_at")
    .single();
  if (ppError) {
    await supabase.from("digital_cards").update({ status: card.status }).eq("id", card.id);
    throw ppError;
  }
  if (!pp.published_at) {
    const { error } = await supabase.from("public_profiles").update({ published_at: new Date().toISOString() }).eq("id", pp.id);
    if (error) throw error;
  }
  return updateMyProfile({ onboarding_completed: true });
}

export function publishErrorMessage(err, fallback) {
  if (err?.code === "P0001" && /entitlement/i.test(err.message || "")) return "Your activation isn't active yet, so we couldn't publish. Nothing was changed.";
  return fallback;
}
